/** Course label factories, fed from i18n so a course reads `코어 A1` / `Core A1` rather than the course code. */
export interface CourseNameLabels {
  core: (level: string) => string
  advanced: (level: string | null) => string
  elite: () => string
}

/**
 * Course codes (`CORE-A1`, `ADVANCED`, `ADVANCED-E`, `ELITE`) as parent- and learner-facing names. Content data
 * keeps the code in both title and bareTitle, so every screen names the courses itself; a title that is not a
 * known code (already a display name) is left as is.
 */
export function courseDisplayName(title: string, labels: CourseNameLabels): string {
  const code = title.trim().toUpperCase()
  const core = /^CORE-([A-Z]\d*)$/.exec(code)
  if (core) return labels.core(core[1])
  const advanced = /^ADVANCED(?:-([A-Z]\d*))?$/.exec(code)
  if (advanced) return labels.advanced(advanced[1] ?? null)
  if (code === 'ELITE') return labels.elite()
  return title
}
